import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import PageTitle from 'hoc/PageTitle';
import EntitiesTableContainer from 'containers/tables/EntitiesTableContainer';
import { ADMINAREA_ACCESS } from 'constants/capabilities';

const ListEntitiesPage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer title="Entities" admin hideDatePicker />}>

        <EntitiesTableContainer {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Entities', showGGBranding: true }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS] }),
)(ListEntitiesPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/ListEntities.js